<a class="tt-button tt-cell-goto" [ngClass]="{ 'tt-cell-goto--wrap-text': wrapText }" (click)="onClick($event)" [style.fontSize]="'var(--ag-grid-fontSize)'">{{ text }}</a>
